import { IconButton, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import { isDarkMode } from 'app/utils/ColorContext';

export const AppIconButton = ({
    action,
    variant,
    style,
    tooltip = '',
    children,
}) => {
    const styling = {
        borderColor: theme =>
            !isDarkMode(theme)
                ? `${theme.palette.grey[400]}!important`
                : `${theme.palette.grey[600]}!important`,
        borderRadius: '5px',
        border: '1px solid',
        width: style?.width ? style.width : 'auto',
        justifyContent: style?.justifyContent ? style.justifyContent : 'center',
        mr: '5px',
        ml: '5px',
    };

    return (
        <Tooltip title={tooltip}>
            <IconButton
                onClick={action}
                variant={variant}
                sx={styling}
                size="small"
            >
                {children}
            </IconButton>
        </Tooltip>
    );
};
